import EnemyData from "./EnemyDataInterface";
import EnemyType from "../../enums/EnemyType";

const GREEN_STAGES_BOSSES: {
    [key in EnemyType]?: EnemyData[];
  } = {
    //replaces SUIT_HAMSTER
    [EnemyType.TIGER]: [
      {
        level: 1, //doesn't seem to impact anything
        maxHp: 30,
        speed: 220,
        power: 20,
        skills: ["HPxLevel"],
        knockback: 1,
        deathKB: 2,
        killedAmount: 0,
        xp: 30,
        spriteName: "tiger",
        animationKey: "tiger_run",
        scale: 1.5,
      },
    ],
    //replaces VAMPIRE_HAMSTER
    [EnemyType.GORILLA]: [
      {
        level: 5,
        maxHp: 80,
        speed: 120,
        power: 50,
        skills: ["HPxLevel"],
        knockback: 0.8,
        deathKB: 2,
        killedAmount: 0,
        xp: 30,
        spriteName: "gorilla",
        animationKey: "gorilla_run",
        scale: 2.5,
      },
    ],
    //replaces LIZARD_HAMSTER
    [EnemyType.RHINOCEROS]: [
      {
        level: 10,
        maxHp: 60,
        speed: 320,
        power: 40,
        knockback: 0.1,
        deathKB: 7,
        skills: ["HPxLevel"],
        killedAmount: 0,
        xp: 2.5,
        spriteName: "rhinoceros",
        animationKey: "rhinoceros_run",
        scale: 1.5,
      },
    ],
    //replaces KING_HAMSTER
    [EnemyType.DARK_KNIGHT]: [
      {
        level: 15,
        maxHp: 200,
        speed: 160,
        power: 80,
        skills: ["HPxLevel"],
        res_Freeze: 0.1,
        knockback: 0,
        deathKB: 5,
        killedAmount: 0,
        scale: 2,
        xp: 25,
        spriteName: "dark_knight",
        animationKey: "dark_knight_run",
      },
    ],
    //replaces SCORPION_BOSS
    [EnemyType.CROCODILE]: [
      {
        level: 1, //doesn't seem to impact anything
        maxHp: 80,
        speed: 140,
        power: 50,
        skills: ["HPxLevel"],
        knockback: 0.5,
        deathKB: 2,
        killedAmount: 0,
        xp: 30,
        spriteName: "crocodile",
        animationKey: "crocodile_run",
        scale: 2,
      },
    ],
    //replaces GOLEM_BOSS
    [EnemyType.LION]: [
      {
        level: 1, //doesn't seem to impact anything
        maxHp: 60,
        speed: 200,
        power: 60,
        skills: ["HPxLevel"],
        knockback: 0.2,
        deathKB: 2,
        killedAmount: 0,
        xp: 30,
        spriteName: "lion",
        animationKey: "lion_run",
        scale: 1.5,
      },
    ],
  };
  export default GREEN_STAGES_BOSSES;